<template>
    <div id="AppointmentDiv">
        <HeaderVue />
        <div class="header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="menu" >
                            <a href="javascript:void(0)" @click="goBackPopup()" style="color:#9e9e9e">
                                <i class="material-icons">
                                    arrow_back
                                </i>
                            </a>
                        </div>
                        <h3 class="screen-title mt-13p">
                            <span class="float-left">
                                Health Cart
                            </span>
                            <!--<div class="float-left cont-number">
                                <h6>Call us at</h6>
                                <h5><a href="tel:+919025662566">+91 90256 62566</a></h5>
                            </div>-->
                            <span class="float-right gray-color">
                                Step 1 of 3
                            </span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="alert alert-info" v-if="isFasting == 1">
                <strong>Info:</strong>&nbsp;One or more of the tests ordered would require fasting. Please make sure you choose a convenient time accordingly.
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="alert alert-success mb-0 drop-shadow" role="alert" v-show="isDateAndTimeChoosed == true">
                       {{ formatDate($localStorage.get('ct').date) }} BETWEEN {{ timeSelected.startTimeDisp }} to {{ timeSelected.endTimeDisp }}
                        <a class="pull-right blue-color" v-on:click="changeDateAndTime()"><i class="fa fa-pencil white-color" aria-hidden="true"></i></a>
                    </div>
                    <p class="confirm-notification" v-if="timeSelected.startTimeDisp && timeSelected.endTimeDisp && formatDate($localStorage.get('ct').date) && isDateAndTimeChoosed">
                        <i class="material-icons green-color float-left mr-2">check</i> Our Phlebotomist will visit as per your selected schedule
                    </p>
                    <span v-if = "!formatDate($localStorage.get('ct').date) ||  !timeSelected.startTimeDisp  ||  !timeSelected.endTimeDisp || !isDateAndTimeChoosed">
                         <p class="text-center gray-color mt-3 mb-1" v-show="isDateAndTimeChoosed == false">
                            Select Sample Pickup Date/Time
                        </p>
                        
                        <button class="btn btn-primary full-width" data-toggle="modal" data-target="#choose-date" >
                            Choose Date / Time
                        </button>
                    </span>
                   
                </div>
                <div class="col-12 mt-4" >
                    <!-- <p class="gray-color mb-1">
                        Before Home Sample Pickup
                    </p>
                    <p class="black-color">
                        Do not eat or drink anything except water at least 9 to 12 hours before the test.
                    </p> -->
                </div>
            </div>
        </div>
        <div class="container-fluid gray-bg">
            <div class="row">
                <div class="col-12">
                    <div class="lab display-flex no-border p-0 mt-3 bg-tranparent">
                        <div class="flex-box">
                            <div class="lab-logo">
                                <img v-if="selectedLab.logo && selectedLab.logo.length > 0" :src="selectedLab.logo" />
                            </div>
                        </div>
                        <div class="flex-box">
                            <p class="black-color font-weight-bold mb-2">
                               {{ selectedLab.labName }}
                            </p>
                            <p class="mt-0 mb-1">{{selectedLab.branch.branchLocation+', '+selectedLab.branch.branchCity+' - '+selectedLab.branch.branchZipCode}}</p>
                            <router-link to="/lab" class="text-uppercase font-weight-bold">Change Lab</router-link> | <a v-on:click="addTest()" class="text-uppercase  font-weight-bold link-blue-color">Add test</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive test-conformation">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="no-border">
                                        Test Name
                                    </th>
                                    <th class="text-right no-border">
                                        Price
                                    </th>
                                    <th class="no-border"></th>
                                </tr>
                            </thead>
                            <tbody class="black-color" v-if="testCosts.priceDetails">
                                <tr v-for="(cost, index) in testCosts.priceDetails" :key="index">
                                    <td>
                                        {{cost.aliasName}}
                                    </td>
                                    <td>
                                        <p class="float-right mt-1 mb-0 price-tag">
                                            <span class="red-color strip-text" v-if='cost.actualPrice > cost.ourPrice'>Rs. {{cost.actualPrice}}</span> Rs. {{cost.ourPrice}}
                                        </p>
                                    </td>
                                    <td>
                                        <button class="btn btn-link remove-btn p-0"  v-on:click="removeSelectedItems(cost, $localStorage.get('st'), $localStorage.get('sl'))">
                                            <img src="static/images/close-black.svg" alt="delete">
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="border-bottom">
                                <tr>
                                    <td>Sub Total</td>
                                    <td>
                                        <p class="float-right mt-1 mb-0 price-tag">
                                            Rs. {{payinfo.total}}
                                        </p>
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-footer p-0" id="fixed-footer">
            <!--<div id="accordion" class="test-details-popover" role="tablist">
                <div class="card m-0">
                    <div class="card-header" role="tab" id="headingOne">
                        <h5 class="mb-0">
                            <a class="collapsed gray-color" data-toggle="collapse" href="#testDetails" aria-expanded="true" aria-controls="testDetails">
                                Test Details
                                <i class="material-icons float-right"></i>
                            </a>
                        </h5>
                    </div>
                    <div id="testDetails" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="lab display-flex no-border p-0 mt-3 bg-tranparent">
                                        <div class="flex-box">
                                            <div class="lab-logo">
                                                <img v-if="selectedLab.logo && selectedLab.logo.length > 0" :src="selectedLab.logo" />
                                            </div>
                                        </div>
                                        <div class="flex-box">
                                            <p class="black-color font-weight-bold mb-2">
                                                {{$localStorage.get('sl').labName}}
                                            </p>
                                            <p class="mt-0 mb-1">{{$localStorage.get('sl').labLocation + ', ' + $localStorage.get('sl').labCity + '-' + $localStorage.get('sl').labZipCode}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row scroll-test">
                                <div class="col-12">
                                    <div class="table-responsive test-conformation">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="no-border">
                                                        Test Name
                                                    </th>
                                                    <th class="text-right no-border">

                                                    </th>
                                                    <th class="no-border text-right">
                                                        Price
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="black-color">
                                                <tr v-for="(cost, index) in testCosts.priceDetails" :key="index">
                                                    <td>
                                                       {{cost.aliasName}}
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td>
                                                        <p class="float-right mt-1 mb-0 price-tag">
                                                             Rs. {{cost.ourPrice}}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table price-table">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        Order Value
                                                    </td>
                                                    <td class="text-right">
                                                       Rs. {{payinfo.total}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="black-color">
                                                        Amount Payable
                                                    </td>
                                                    <td class="text-right black-color">
                                                       Rs. {{payinfo.grandTotal}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
            <button v-if="!$localStorage.get('profile')" :disabled="(!dt || !timeSelected)"  class="btn btn-primary full-width fixed-button" v-bind:class="{'btn-secondary': (!dt || !timeSelected), 'btn-primary' : !(!dt || !timeSelected)}"  data-toggle="modal" data-target=".login-box" data-backdrop="static" data-keyboard="false" v-on:click="$root.$emit('appointmentLogin',true); fbTriggerDate()">Proceed to checkout</button>
            <button v-else class="btn btn-primary full-width fixed-button" :disabled="(!dt || !timeSelected)" v-bind:class="{'btn-secondary': (!dt || !timeSelected), 'btn-primary': !(!dt || !timeSelected) }" v-on:click="goChooseLocation()">Proceed to checkout</button>
        </div>
         <FooterVue /> 
        <div class="modal fade" id="choose-date" tabindex="-1" role="dialog" aria-labelledby="choose-dateLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-show="isDateAndTimeChoosed == false">
                    <!--<div class="modal-header">
                        <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close" >
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>
                        <h5 class="modal-title" id="choose-dateLabel" >
                            Choose Date / Time
                        </h5>
                    </div>-->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Choose Date / Time</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0" >
                        <div class="row primary-bg pt-3 pb-3">
                            <div class="col-6" >
                                <a class="white-color"  v-on:click="showhide()">
                                    <p class="mb-2">Date</p>
                                    <h5 class="mt-0 opacity-50" style="color:#fbf5f5">{{ formatDate($localStorage.get('ct').date) }}</h5>
                                </a>
                            </div>
                            <div class="col-6" v-if="timeSelected.startTimeDisp && timeSelected.endTimeDisp">
                                <a class="white-color"  v-on:click="timepicker=true; datepicker=false;">
                                    <p class="mb-2">Time</p>
                                    <h5 class="mt-0 opacity-50" style="color:#fbf5f5">{{ timeSelected.startTimeDisp + ' to ' + timeSelected.endTimeDisp }}</h5>
                                </a>
                            </div>
                            <div class="col-6" v-else>
                                <a class="white-color"  v-on:click="timepicker=true; datepicker=false;">
                                    <p class="mb-2">Time</p>
                                    <h5 class="m-0 opacity-50" style="color:#fbf5f5">HR:MIN</h5>
                                </a>
                            </div>
                        </div>
                        <div id="dateAndTime" v-if="isDatePickerOpend" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                                <div class="datepicker-box" v-show="datepicker">
                                    <div class="form-group">
                                        <div class="row" style="padding-top:10%">
                                            <div class="col-6">
                                                <p class="text-left">Choose Date</p>
                                            </div>
                                            <div class="col-6">
                                                <p class="text-right" v-on:click="timepicker=true; datepicker=false">
                                                    <span class="mt-2"> Edit Time</span>
                                                    &nbsp;<i class="material-icons float-right mr-2">arrow_forward</i>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <datepicker :inline="true" :value="dt"
                                                v-model="dt" :format="'dd/MM/yyyy'"  v-on:selected="dateChange" :disabled="disabled"></datepicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="timepicker" v-show="timepicker">
                                    <div class="row mt-3">
                                        <div class="col-6">
                                            <p class="text-left" v-on:click="showhide()">
                                                <i class="material-icons float-left mr-2">keyboard_backspace</i>
                                                <span class="mt-2"> Edit Date</span>
                                            </p>
                                        </div>
                                        <div class="col-6">
                                            <p class="text-center gray-color">Choose Time Slot</p>
                                        </div>
                                    </div>
                                    <!--<div class="row">-->
                                        <!--<ul class="time-list"  v-if="availableTimes" style="margin:0px !important">
                                            <li  v-for="(value, index) in availableTimes.slice(0, 5)" :key='index' v-bind:class="{'active':(timeSelected.startTime === value.startTime) && (timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}">
                                                <label class="time-chips m-0" v-if="value.isEnable" v-on:click="setTime(value)">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                                <label class="time-chips m-0" v-if="!value.isEnable">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                            </li>
                                    
                                            <li v-for="(value, index) in availableTimes.slice(5, 10)" :key='index' v-bind:class="{'active':(timeSelected.startTime === value.startTime) && (timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}">
                                                <label class="time-chips m-0" v-if="value.isEnable" v-on:click="setTime(value)">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                                <label class="time-chips m-0" v-if="!value.isEnable">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                            </li>
                                            
                                            <li v-for="(value, index) in availableTimes.slice(10, 15)" :key='index' v-bind:class="{'active':((timeSelected.startTime == value.startTime) && (timeSelected.endTime == value.endTime)), 'disabled': (value.isEnable === false)}">
                                                <label class="time-chips m-0" v-if="value.isEnable" v-on:click="setTime(value)">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                                <label class="time-chips m-0" v-if="!value.isEnable" :disabled="true">
                                                    {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                </label>
                                            </li>
                                        </ul>-->
                                        <div class="row">
                                            <div class="col-sm-12 p-0">
                                                <hr class="mt-0">
                                                <ul class="key-points">
                                                    <li>
                                                        <span class="circle-point available"></span> Available</li>
                                                    <li>
                                                        <span class="circle-point booked"></span> Un-Available</li>
                                                    <li>
                                                        <span class="circle-point selected"></span> Selected Time</li>
                                                </ul>
                                                <hr>
                                            </div>
                                            </div>
                                        <div v-if="availableTimes">
                                            <ul class="time-list">
                                                <li v-for="(value, index) in availableTimes" v-bind:class="{'active':(timeSelected.startTime === value.startTime) && (timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}">
                                                    <label class="time-chips m-0" v-if="value.isEnable" v-on:click="setTime(value)">
                                                        {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                    </label>
                                                    <label class="time-chips m-0" v-if="!value.isEnable">
                                                        {{value.startTimeDisp}} - {{value.endTimeDisp}}
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                        
                                        <!-- </div> -->
                                    <!--</div>-->
                                    <!--<div class="row">
                                        <div class="col-md-4 offset-8">
                                            <button class="btn btn-sm btn-primary full-width float-right" :disabled="!(dt && timeSelected)" @click.prevent="saveDateAndTime()">Save</button>
                                        </div>
                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Login />
    </div>
</template>

<script>
import Vue from 'vue'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Login from '@/components/mobile/Login'
import _ from 'underscore'
import Datepicker from 'vuejs-datepicker'
import dateFormat from 'dateformat'

var myDate = new Date()

export default {
  name: 'AppointmentDate',
  components: {
    HeaderVue,
    FooterVue,
    Datepicker,
    Login
  },
  beforeCreate () {
    if (!this.$localStorage.get('st')) {
      this.$router.push('/lab')
      return false
    }
    if (!this.$localStorage.get('sl')) {
      this.$router.push('/lab')
      return false
    }
    myDate = new Date()
    myDate.setDate(myDate.getDate() - 1)
  },
  data () {
    return {
      isDatePickerOpend: true,
      datepicker: true,
      timepicker: false,
      disabled: {
        to: myDate
      },
      language: 'en',
      payinfo: {
        mrpTotal: 0,
        phlebotomistFee: 0,
        subTotal: 0,
        labDiscount: 0,
        phlebotomyFeeWaiver: 0,
        total: 0,
        gst: 0,
        grandTotal: 0
      },
      dt: '',
      timeSelected: '',
      availableTimes: [
        { startTime: '06:00', endTime: '07:00', startTimeDisp: '06:00', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
        // { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
        { startTime: '07:00', endTime: '08:00', startTimeDisp: '07:00', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
        // { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
        { startTime: '08:00', endTime: '09:00', startTimeDisp: '08:00', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
        // { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
        { startTime: '09:00', endTime: '10:00', startTimeDisp: '09:00', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
        // { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
        { startTime: '10:00', endTime: '11:00', startTimeDisp: '10:00', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
        // { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
        { startTime: '11:00', endTime: '12:00', startTimeDisp: '11:00', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
        // { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
        { startTime: '12:00', endTime: '13:00', startTimeDisp: '12:00', endTimeDisp: '1:00 pm', isEnable: true, isActive: false },
        // { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false },
        { startTime: '13:00', endTime: '14:00', startTimeDisp: '01:00', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
        // { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
        { startTime: '14:00', endTime: '15:00', startTimeDisp: '02:00', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
        // { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
        { startTime: '15:00', endTime: '16:00', startTimeDisp: '03:00', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
        // { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
        { startTime: '16:00', endTime: '17:00', startTimeDisp: '04:00', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
        // { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
        { startTime: '17:00', endTime: '18:00', startTimeDisp: '05:00', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
        // { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
        { startTime: '18:00', endTime: '19:00', startTimeDisp: '06:00', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
        // { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
        { startTime: '19:00', endTime: '20:00', startTimeDisp: '07:00', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
        // { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
        { startTime: '20:00', endTime: '21:00', startTimeDisp: '08:00', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }
        // { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }
      ],
      selectedLab: [],
      selectedProfileAndTest: [],
      isFasting: 0,
      testCosts: [],
      GSTFee: this.$GSTFee,
      isDateAndTimeChoosed: false
    }
  },
  methods: {
    addTest: function () {
      this.$localStorage.set('addTest', true)
      this.$router.push({path: '/lab'})
    },
    showdtandTime: function () {
      $('#show-time').modal('show')
      this.timepicker = true
      this.datepicker = false
    },
    savePopup: function () {
     $('#show-time').modal('hide')
     $('choose-date').modal('hide')
    },
    goBackPopup: function () {
      this.$router.push({path: '/lab'})
    },
    openDatePicker: function () {
      this.isDatePickerOpend = !this.isDatePickerOpend
    },
    removeSelectedItems: function (cost, selectedTests, selectedLab) {
      let confirmText = 'Are you sure you want to remove?'
      if (selectedTests.length === 1) {
        confirmText = 'Are you sure you want to remove last one?'
      }
      let confirmFn = function () {
        this.$localStorage.remove('st')
        this.$localStorage.remove('cou')
        let reFetcheditems = []
        selectedTests.forEach(function (items) {
          console.log(items)
          if (!(items.testId === cost.testId && cost.panelId === items.panelId)) {
            reFetcheditems.push(items)
          }
        })
        console.log(reFetcheditems)
        this.$localStorage.set('st', reFetcheditems, 0)

        let reFetchedLabitems = []
        if (selectedLab) {
          if ((selectedLab.labTestList).length > 0) {
            selectedLab.labTestList.forEach(function (labTest) {
              console.log(labTest)
              if (!(labTest.labProfileId === cost.labProfileId)) {
                reFetchedLabitems.push(labTest)
              }
            })
          }
        }
        selectedLab.labTestList = reFetchedLabitems
        console.log(selectedLab)
        this.$localStorage.set('sl', selectedLab, 30 * 60 * 1000)

        this.getTestCosts()
        this.getFastingTests()

        if (selectedTests.length === 1) {
          this.$router.push('/lab')
        }
      }.bind(this)

      this.$Simplert.open({
        title: 'Confirm',
        message: confirmText,
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      })
    },
    saveDateAndTime: function () {
      this.isDateAndTimeChoosed = true
    },
    changeDateAndTime: function () {
      $('#choose-date').modal('show')
      this.datepicker = false
      this.timepicker = true
      this.isDateAndTimeChoosed = false
      this.isDatePickerOpend = true
    },
    showhide: function () {
    //   $('#choose-date').modal('show')
      this.datepicker = true
      this.timepicker = false
    },
    formatDate: function (date) {
      return dateFormat(date, 'dd/mm/yyyy')
    },
    goChooseLocation: function () {
      this.$localStorage.remove('sa')
      this.$localStorage.remove('sm')
      this.$localStorage.remove('cou')
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: 'APPOINTMENT DATE',
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      })
      this.$router.push({ path: '/address' })
      return false
    },
    fbTriggerDate: function () {
      if (this.$localStorage.get('ct').fromDateTime) {
        $('.login-box').modal('show')
        // $('.login-box').modal('show')
      }
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: this.$localStorage.get('ct').fromDateTime,
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      })
    },
    formatAMPM: function (time) {
      let setDate = new Date('2017-01-01 '.replace(/-/g, '/') + time.toString())
      let hours = setDate.getHours()
      let minutes = setDate.getMinutes()
      let ampm = hours >= 12 ? 'pm' : 'am'
      hours = hours % 12
      if (hours === 0) {
        hours = 12
      }
      minutes = minutes < 10 ? '0' + minutes : minutes
      let strTime = (((hours.toString()).length === 1) ? '0' : '') + hours + ':' + minutes + ' ' + ampm
      return strTime
    },
    getAvailableTime: function (date) {
      var self = this
      try {
        let data = {
          'appointmentDate': dateFormat(date, 'yyyy/mm/dd'),
          'zipCode': this.$localStorage.get('location') ? this.$localStorage.get('location').locationZipCode : this.$defaultPincode,
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0'
        }
        let availableTimes = []
        Promise.resolve(this.$GET('patient/getAvailableTime', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.length > 0) {
              _.each(res.response, function (ele, key) {
                let parts = ele.time.split(':')
                let endTime = (parseInt(parts[0]) + 1) + ':00:00'
                // if (parseInt(parts[1]) === 0) {
                //   endTime = parts[0] + ':30:01'
                // } else {
                //   endTime = (parseInt(parts[0]) + 1) + ':00:01'
                // }
                let arrayObj = {
                  startTime: (ele.time),
                  startTimeDisp: (self.formatAMPM(ele.time)).replace(' am', '').replace(' pm', ''),
                  endTime: (endTime),
                  endTimeDisp: self.formatAMPM(endTime),
                  isEnable: ele.isAvailable === 1,
                  isActive: false
                }
                let endTimeSplitArray = ele.time.split(':')
                if (dateFormat(date, 'yyyy/mm/dd') === dateFormat(new Date(), 'yyyy/mm/dd')) {
                  if (parseInt(endTimeSplitArray[0]) < parseInt(dateFormat(new Date(), 'HH'))) {
                    arrayObj['isEnable'] = false
                  }
                  if (parseInt(endTimeSplitArray[0]) === parseInt(dateFormat(new Date(), 'HH')) && parseInt(endTimeSplitArray[1]) <= parseInt(dateFormat(new Date(), 'mm'))) {
                    arrayObj['isEnable'] = false
                  }
                }
                availableTimes.push(arrayObj)
                endTime = undefined
                parts = undefined
              })
              this.availableTimes = availableTimes
            }
          }
          this.$hidePageLoading()
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getTestCosts: function (lab) {
      try {
        let labTestCosts = []
        if (this.$localStorage.get('sl')) {
          if ((this.$localStorage.get('sl').labTestList).length > 0) {
            _.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        let data = {
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        }
        Promise.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response
              this.payinfo.mrpTotal = res.response.mrp
              this.payinfo.phlebotomistFee = this.$phlebotomistFee
              this.payinfo.subTotal = (this.payinfo.mrpTotal + this.payinfo.phlebotomistFee)
              this.payinfo.labDiscount = res.response.youSaved
              this.payinfo.phlebotomyFeeWaiver = ((this.payinfo.mrpTotal - this.payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              this.payinfo.total = this.payinfo.subTotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver)
              this.payinfo.gst = Math.round(((this.payinfo.total) * this.$GSTFee) / 100)
              this.payinfo.grandTotal = (this.payinfo.total + this.payinfo.gst)
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getFastingTests: function () {
      try {
        this.isFasting = 0
        var data = this.$localStorage.get('st')
        Promise.resolve(this.$POST('patient/getFastingTests', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.isFasting === 1) {
              this.isFasting = 1
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log('error', e)
      }
    },
    dateChange: function (dt) {
      $('#show-time').modal('show')
      this.$parent.$children[0].step = this.step
      this.$parent.$children[0].current = 'health'
      this.datepicker = false
      this.timepicker = true
      this.timeSelected = ''
      this.dt = dt
      let d = new Date(dt)
      let sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateFormat(d, 'yyyy-mm-dd', true),
        time: this.timeSelected,
        fromDateTime: dateFormat(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateFormat(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      }
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000)
      this.isDateAndTimeChoosed = false
      this.getAvailableTime(dt)
    },
    setTime: function (value) {
      this.timeSelected = value
      let d = new Date(this.dt)
      let sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateFormat(d, 'yyyy-mm-dd'),
        time: this.timeSelected,
        fromDateTime: dateFormat(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.startTime,
        toDateTime: dateFormat(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.endTime,
        tz: new Date().getTimezoneOffset()
      }
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000)
      this.isDateAndTimeChoosed = true
      $('#choose-date').modal('hide')
      console.log('Selected Date:')
      console.log(this.dt)
      console.log('Selected Time:')
      console.log(this.timeSelected)
    }
  },
  created () {
    console.log('appointment-created')
    console.log(this.$step)
    this.$step = true
    console.log(this.$step)
    this.selectedLab = []
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl')
    }
    this.selectedProfileAndTest = []
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st')
    }
    this.timeSelected = ''
    if (this.$localStorage.get('ct') && this.$localStorage.get('ct').time && this.$localStorage.get('ct').date) {
      this.dt = this.$localStorage.get('ct').date
      this.timeSelected = this.$localStorage.get('ct').time
      this.getAvailableTime(this.dt)
      this.isDateAndTimeChoosed = true
      this.isDatePickerOpend = false
    } else {
      let d = new Date()
      let dDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateFormat(d, 'yyyy-mm-dd', true),
        time: '',
        fromDateTime: dateFormat(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateFormat(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      }
      this.dt = d
      this.$localStorage.set('ct', dDatetime, 30 * 60 * 1000)
      this.isDateAndTimeChoosed = false
      this.availableTimes = [
        { startTime: '06:00', endTime: '06:30', startTimeDisp: '06:00', endTimeDisp: '06:30 am', isEnable: true, isActive: false },
        { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
        { startTime: '07:00', endTime: '07:30', startTimeDisp: '07:00', endTimeDisp: '07:30 am', isEnable: true, isActive: false },
        { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
        { startTime: '08:00', endTime: '08:30', startTimeDisp: '08:00', endTimeDisp: '08:30 am', isEnable: true, isActive: false },
        { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
        { startTime: '09:00', endTime: '09:30', startTimeDisp: '09:00', endTimeDisp: '09:30 am', isEnable: true, isActive: false },
        { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
        { startTime: '10:00', endTime: '10:30', startTimeDisp: '10:00', endTimeDisp: '10:30 am', isEnable: true, isActive: false },
        { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
        { startTime: '11:00', endTime: '11:30', startTimeDisp: '11:00', endTimeDisp: '11:30 am', isEnable: true, isActive: false },
        { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
        { startTime: '12:00', endTime: '12:30', startTimeDisp: '12:00', endTimeDisp: '12:30 pm', isEnable: true, isActive: false },
        { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false },
        { startTime: '13:00', endTime: '13:30', startTimeDisp: '01:00', endTimeDisp: '01:30 pm', isEnable: true, isActive: false },
        { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
        { startTime: '14:00', endTime: '14:30', startTimeDisp: '02:00', endTimeDisp: '02:30 pm', isEnable: true, isActive: false },
        { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
        { startTime: '15:00', endTime: '15:30', startTimeDisp: '03:00', endTimeDisp: '03:30 pm', isEnable: true, isActive: false },
        { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
        { startTime: '16:00', endTime: '16:30', startTimeDisp: '04:00', endTimeDisp: '04:30 pm', isEnable: true, isActive: false },
        { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
        { startTime: '17:00', endTime: '17:30', startTimeDisp: '05:00', endTimeDisp: '05:30 pm', isEnable: true, isActive: false },
        { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
        { startTime: '18:00', endTime: '18:30', startTimeDisp: '06:00', endTimeDisp: '06:30 pm', isEnable: true, isActive: false },
        { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
        { startTime: '19:00', endTime: '19:30', startTimeDisp: '07:00', endTimeDisp: '07:30 pm', isEnable: true, isActive: false },
        { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
        { startTime: '20:00', endTime: '20:30', startTimeDisp: '08:00', endTimeDisp: '08:30 pm', isEnable: true, isActive: false },
        { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }
      ]
      this.getAvailableTime(d)
    }
    this.getTestCosts()
    this.getFastingTests()
    this.GSTFee = this.$GSTFee
    if (!this.isDateAndTimeChoosed) {
        setTimeout(function () {
          $('#choose-date').modal('show')
        }, 400)
    }
  },
  mounted: function () {
    this.$parent.$children[0].step = this.step
    this.$parent.$children[0].current = 'health'
  }

}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
ul.time-list li {
    font-size: 12px;
    border: 1px solid #e1e1e1;
    color: #939393;
    border-radius: 5px;
    padding: 5px;
    background-color: #FFF !important;
    cursor: pointer;
}
ul.time-list li label {
    cursor: pointer;
}
ul.time-list li.disabled
{
  background-color: #f1f1f1 !important;
  pointer-events: none !important;
  cursor: none;
}
ul.time-list li.active
{
  background-color: #333333 !important;
  pointer-events: none !important;
  cursor: none;
  color: #FFF;
  border-color: #333;
}
.portal-section {
    padding-top: 25px;
}
/* .confirm-notification {
  margin-top: 1rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/mobile/Book/Appointment.vue